import { render, staticRenderFns } from "./tabAttachment.vue?vue&type=template&id=a097f202&scoped=true"
import script from "./tabAttachment.vue?vue&type=script&lang=js"
export * from "./tabAttachment.vue?vue&type=script&lang=js"
import style0 from "./tabAttachment.vue?vue&type=style&index=0&id=a097f202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a097f202",
  null
  
)

export default component.exports